module.exports = __webpack_public_path__ + "57651a1449e9808a9aeb12c422b7a163.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/productivity.svg
// module id = 1934
// module chunks = 0